import { useApp } from "../context";
import { Heading, Table, CaseLink, Filters, Badge } from "../components/Bits";
import { money, expected, received, outstanding, paid, collectionStatus, visibleCases } from "../lib/engine";

export default function Reconciliation() {
  const { state, search, region, openModal, actions, actor } = useApp();
  return (
    <>
      <Heading title="Reconciliation" description="Expected bank commission versus receipts and DSA payments.">
        <div className="actions">
          <button data-testid="csv-template-btn" onClick={actions.downloadTemplate}>CSV template</button>
          <button className="primary" data-testid="import-receipts-btn" disabled={actor !== "checker"}
            title={actor !== "checker" ? "Finance checker account required" : undefined} onClick={() => openModal({ type: "import" })}>
            Import receipts
          </button>
        </div>
      </Heading>
      <div className="notice warning">
        Exact case, disbursement and bank references are required.
        Duplicate receipt IDs and amounts above the outstanding balance are blocked.
        Imports are validated as a complete batch before posting.
      </div>
      <div className="card">
        <Filters />
        <Table testId="reconciliation-table"
          headers={["Case", "Expected bank", "Received", "Outstanding", "DSA paid", "Status / due"]}>
          {visibleCases(state, search, region).map(c => (
            <tr key={c.id} data-testid={`recon-row-${c.id}`}>
              <td><CaseLink c={c} /></td>
              <td className="number">{money(expected(c))}</td>
              <td className="number" data-testid={`recon-received-${c.id}`}>{money(received(state, c))}</td>
              <td className="number" data-testid={`recon-outstanding-${c.id}`}>{money(outstanding(state, c))}</td>
              <td className="number">{money(paid(state, c))}</td>
              <td><Badge text={collectionStatus(state, c)} testId={`recon-status-${c.id}`} /><small>{c.due}</small></td>
            </tr>
          ))}
        </Table>
      </div>
      <div className="card space">
        <h2>Receipt ledger</h2>
        <Table testId="receipt-ledger-table" headers={["Receipt ID", "Case / tranche", "Bank", "Amount", "Date"]}>
          {state.receipts.map(r => (
            <tr key={r.id}>
              <td>{r.external}</td>
              <td>{r.caseId}<small>{r.disb}</small></td>
              <td>{r.bank}</td>
              <td className="number">{money(r.amount)}</td>
              <td>{r.date}</td>
            </tr>
          ))}
        </Table>
      </div>
    </>
  );
}
